import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'wilson-datenschutz',
  templateUrl: './datenschutz.component.html',
  styleUrls: ['./datenschutz.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DatenschutzComponent {}
